module.exports = __webpack_public_path__ + "img/博聖さまアイコン正面.c318d5f4.jpg";